export const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;